import React from 'react'
import i18n from '~/i18n'

const OUTCOME_KEYS = [
    'mcp:preview.outcomes.contacts',
    'mcp:preview.outcomes.campaigns',
    'mcp:preview.outcomes.automations',
    'mcp:preview.outcomes.insights',
    'mcp:preview.outcomes.bridge'
]

const SAMPLE_PROMPT_KEYS = [
    'mcp:examples.prompts.countContacts',
    'mcp:examples.prompts.campaignStats',
    'mcp:examples.prompts.listAutomations',
    'mcp:examples.prompts.recentVisitors',
    'mcp:examples.prompts.improveDeliverability'
]

export default function CapabilityTeaser() {
    return (
        <div className='mcp-preview'>
            <div className='mcp-preview__heading'>
                <div className='mcp-preview__label'>{i18n.t('mcp:preview.label')}</div>
                <p className='mcp-preview__hint'>{i18n.t('mcp:preview.hint')}</p>
            </div>
            <ul className='mcp-preview__outcomes'>
                {OUTCOME_KEYS.map((key) => (
                    <li key={key}>{i18n.t(key)}</li>
                ))}
            </ul>
            <div className='mcp-preview__prompts' aria-hidden='true'>
                {SAMPLE_PROMPT_KEYS.map((key) => (
                    <span key={key} className='mcp-preview__chip'>
                        {i18n.t(key)}
                    </span>
                ))}
            </div>
        </div>
    )
}
